export default __webpack_public_path__ + "static/insta-hotels-13-cdc35ad24b708bc890dedf4a6671591f.jpg";